import { render } from "./PageTemplate.vue?vue&type=template&id=418f3662&scoped=true"
import script from "./PageTemplate.vue?vue&type=script&lang=js"
export * from "./PageTemplate.vue?vue&type=script&lang=js"

import "./PageTemplate.vue?vue&type=style&index=0&id=418f3662&scoped=true&lang=css"

import exportComponent from "/Users/afolabitope/Documents/apps/redge/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-418f3662"]])

export default __exports__